import { Text, View, StyleSheet } from '@react-pdf/renderer';
import PDFPage from './PDFDocument';
import { disclaimerFull, disclaimerSectionHeading } from '../../lib/disclaimer';

const styles = StyleSheet.create({
  intro: {
    fontSize: 11,
    color: '#000000',
    lineHeight: 1.4,
    marginBottom: 14,
    textAlign: 'left',
  },
  sectionHeading: {
    fontSize: 14,
    fontWeight: 'bold',
    color: '#1d428a',
    marginBottom: 8,
  },
  paragraph: {
    fontSize: 11,
    color: '#000000',
    lineHeight: 1.4,
    marginBottom: 10,
    textAlign: 'left',
  },
});

// Dedicated full-disclosure page. Larger, clearly readable font (11pt) vs. the
// 8pt footer. The page footer disclaimer is suppressed here to avoid duplicating
// the disclosure with itself.
const DisclosurePagePDF = ({ pageNumber }) => {
  const [intro, ...rest] = disclaimerFull;

  return (
    <PDFPage
      header="Important Disclosures"
      pageNumber={pageNumber}
      showDisclaimer={false}
      showFooter={true}
    >
      <Text style={styles.intro}>{intro}</Text>
      <Text style={styles.sectionHeading}>{disclaimerSectionHeading}</Text>
      {rest.map((para, i) => (
        <Text key={i} style={styles.paragraph}>{para}</Text>
      ))}
    </PDFPage>
  );
};

export default DisclosurePagePDF;
